<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<!------------ START TEMPLATE ------------>
<template>
  <div
    v-if="exibir == true"
    id="data-list-list-view"
    class="data-list-container"
  >
    <div
      class="sm:hidden bg-success fixed bottom-0 left-0 w-full text-center p-6 adicionaPropostaMobile"
    >
      <div
        class="text-white"
        @click="novaProposta()"
        v-if="$can($actionsDefault.Escrita, subjectPermission) && !vistoria"
      >
        <feather-icon class="" icon="PlusCircleIcon" svgClasses="h-5 w-5" />
        <span class="ml-2">Adicionar nova Proposta</span>
      </div>
    </div>

    <ModalHistorico :dadosHistorico="dadosHistorico" />

    <div>
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between pt-4"
      >
        <div class="hidden sm:flex flex-wrap-reverse items-center">
          <div
            class="py-4 px-6 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between bg-success text-white"
            @click="novaProposta()"
            v-if="$can($actionsDefault.Escrita, subjectPermission) && !vistoria"
          >
            <feather-icon icon="PlusCircleIcon" svgClasses="h-5 w-5" />
            <span class="ml-2">Adicionar nova Proposta</span>
          </div>
        </div>

        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
          data-testId="dropdown"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2">
              {{ paginaAtual * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                paginaAtual * itemsPerPage < qtdTotal
                  ? paginaAtual * itemsPerPage
                  : qtdTotal
              }}
              de {{ qtdTotal }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item
              @click="itemsPerPage = 5"
              data-testId="dropdown-item-5"
            >
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="itemsPerPage = 10"
              data-testId="dropdown-item-10"
            >
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="itemsPerPage = 25"
              data-testId="dropdown-item-25"
            >
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="itemsPerPage = 50"
              data-testId="dropdown-item-50"
            >
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <vs-card class="showMobile">
        <vs-pagination
          :max="screenWidth < 650 ? 5 : 9"
          v-if="qtdPaginas > 1"
          :total="qtdPaginas"
          v-model="paginaAtual"
          data-testId="pagination"
        ></vs-pagination>
      </vs-card>

      <vs-card v-if="!qtdPaginas" class="flex justify-center p-4">
        <h5 class="mt-2">Nenhuma Proposta Encontrada</h5>
      </vs-card>

      <div v-for="item in itens" :key="item.id">
        <div class="relative pb-4 mb-6">
          <vs-card>
            <div class="vx-row">
              <div class="vx-col flex w-full justify-between">
                <div class="flex w-11/12 lg:w-full justify-between ml-2">
                  <div class="vx-col flex gap-1 mt-2 mb-4">
                    <vs-chip
                      class="divIdProposta rounded"
                      v-if="
                        (!vistoria && isPolicy(item)) || isEndorsement(item)
                      "
                      color="#0000ff"
                    >
                      {{ getPolicyNumberTagText(item) }}
                    </vs-chip>
                    <vs-chip
                      v-if="isProposal(item)"
                      class="divIdProposta rounded"
                      color="#2b50bb"
                    >
                      {{ getProposalIdTagText(item) }}
                    </vs-chip>
                    <vs-chip class="divIdProposta rounded" color="#078fcf">
                      COTAÇÃO {{ item.idProposta }}
                    </vs-chip>
                    <vs-chip class="divIdProposta rounded" color="#2b50bb"
                      >{{ getApolicesTagText(item.idTipoApolice) }}
                    </vs-chip>
                    <vs-chip
                      color="#078fcf"
                      class="divIdProposta rounded"
                      v-if="vistoria"
                    >
                      {{ item.tipoProposta }}
                    </vs-chip>
                    <vs-chip
                      class="divIdProposta rounded"
                      v-if="!vistoria"
                      :color="getStatusColor(item.nomeStatus)"
                    >
                      {{ item.nomeStatus }}
                    </vs-chip>
                    <vs-chip
                      class="divIdProposta rounded"
                      v-if="
                        vistoria &&
                        needInspectionLabel(
                          item.needInspection,
                          item.dataVistoria,
                        ).showLabel
                      "
                      color="warning"
                    >
                      {{
                        needInspectionLabel(
                          item.needInspection,
                          item.dataVistoria,
                        ).label
                      }}
                    </vs-chip>
                    <vs-chip
                      class="divIdProposta rounded"
                      v-if="item.creationType === 'ENDORSEMENT'"
                      color="#9D00FF"
                    >
                      ENDOSSO
                    </vs-chip>

                    <div class="divInfo mt-1">
                      {{ functions.formatDateAndHour(item.dataCotacao) }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="vx-col w-full lg:flex lg:justify-between ml-2">
                <div class="gap-3 mb-4 lg:w-full mr-2">
                  <div class="divSubTitle">
                    {{ item.dadosCliente.associado }}
                  </div>
                  <div class="divInfo">{{ item.cpfcnpj }}</div>
                  <div class="divInfo">{{ item.email }}</div>
                  <div v-if="!item.celular" class="divInfo">
                    {{ item.telefone }}
                  </div>
                  <a
                    target="_blank"
                    :href="`https://wa.me/55${item.celular
                      .replace('(', '')
                      .replace(')', '')
                      .replace(' ', '')
                      .replace('-', '')}`"
                    v-else
                    class="divInfo cursor-pointer"
                  >
                    {{ item.celular }}
                    <vs-icon color="success" icon-pack="fa" icon="fa-whatsapp">
                    </vs-icon>
                  </a>
                </div>
                <div class="mb-4 lg:block flex gap-2 lg:w-full mr-2">
                  <p class="divTitle">USUÁRIO</p>
                  <div class="divInfo">
                    {{ item.nomeVendedor }}
                  </div>
                </div>

                <div
                  v-if="!vistoria"
                  class="gap-2 mb-4 lg:block flex lg:w-full mr-2"
                >
                  <p class="divTitle">CIDADE/UF</p>
                  <div class="divInfo">
                    {{ item.cidade }} / {{ item.estado }}
                  </div>
                </div>

                <div
                  v-if="vistoria"
                  class="lg:block flex gap-2 mb-4 lg:w-full mr-2"
                >
                  <p class="divTitle">RESPONSÁVEL</p>
                  <div class="divInfo">
                    {{ item.nomeResponsavel }}
                  </div>
                </div>

                <div
                  v-if="vistoria"
                  class="lg:block flex gap-2 mb-4 lg:w-full mr-2"
                >
                  <p class="divTitle">RECUSAS</p>
                  <div class="divInfo">
                    {{ item.qtdRecusa ? item.qtdRecusa : 0 }}
                  </div>
                </div>

                <div class="flex justify-end gap-1">
                  <button
                    v-if="
                      vistoria == true &&
                      (($can('Assumir Responsabilidade', 'Vistorias') &&
                        item.nomeResponsavel == null) ||
                        $can('Editar Responsável Vistoria', 'Vistorias'))
                    "
                    type="button"
                    v-tooltip="'Assumir responsábilidade pela análise'"
                    class="vs-button vs-button-warning vs-button-gradient includeIcon includeIconOnly vs-radius text-white text-lg"
                    @click="
                      abrirModalConfirmacaoResponsavelVistoria(item.idProposta)
                    "
                    data-testId="open-responsible-popup-main"
                  >
                    <vs-icon icon-pack="feather" icon="icon-user" />
                  </button>

                  <div
                    v-if="
                      vistoria == true &&
                      (((item.dataVistoria ||
                        item.nomeStatus ==
                          STATUS_PROPOSTA.AGUARDANDO_APROVACAO.name ||
                        item.nomeStatus == STATUS_PROPOSTA.FINALIZADO.name ||
                        item.nomeStatus ==
                          STATUS_PROPOSTA.EM_PROCESSO_VISTORIA.name ||
                        item.nomeStatus == STATUS_PROPOSTA.PENDENTE.name) &&
                        $can('Visualizar Vistoria', subjectPermission)) ||
                        $can(
                          'Aprovar proposta sem vistoria',
                          subjectPermission,
                        ))
                    "
                  >
                    <a
                      v-tooltip="'Detalhes da Vistoria'"
                      :href="`detalheVistoria/${item.idProposta}`"
                      class="vs-button vs-button-dark vs-button-gradient includeIcon includeIconOnly vs-radius text-white text-lg"
                      data-testId="view-inspection-details-main"
                    >
                      <i class="feather icon-camera"></i>
                    </a>
                  </div>

                  <div class="dropdownAcoes">
                    <vs-dropdown
                      vs-trigger-click
                      class="flex cursor-pointer"
                      data-testId="actions-dropdown"
                    >
                      <div
                        class="rounded-full cursor-pointer vs-button-primary vs-button-gradient"
                      >
                        <vs-icon
                          round
                          class="m-1"
                          size="medium"
                          color="white"
                          icon="more_horiz"
                        ></vs-icon>
                      </div>

                      <vs-dropdown-menu style="width: 250px">
                        <vs-dropdown-item
                          v-if="!isLifeTypePolicy(item.idTipoApolice)"
                          :to="linkMenuEditar(item)"
                          data-testId="edit-menu-item"
                        >
                          <div class="flex gap-3">
                            <vs-icon
                              color="success"
                              icon-pack="feather"
                              icon="icon-edit"
                            >
                            </vs-icon>
                            <span>{{
                              isCotacao(item)
                                ? `${cotacaoLabel(item.nomeStatus)}`
                                : 'Detalhes da Proposta'
                            }}</span>
                          </div>
                        </vs-dropdown-item>

                        <vs-dropdown-item
                          v-if="
                            vistoria == true &&
                            (($can('Assumir Responsabilidade', 'Vistorias') &&
                              item.nomeResponsavel == null) ||
                              $can('Editar Responsável Vistoria', 'Vistorias'))
                          "
                          divider
                          class="pt-2"
                          @click="
                            abrirModalResponsavelVistoria(
                              item.idProposta,
                              item.idResponsible,
                              item.nomeResponsavel,
                            )
                          "
                          data-testId="open-responsible-popup-item"
                        >
                          <div class="flex gap-3">
                            <vs-icon
                              color="warning"
                              icon-pack="feather"
                              icon="icon-user"
                            >
                            </vs-icon>
                            <span>Assumir Responsabilidade pela Análise</span>
                          </div>
                        </vs-dropdown-item>

                        <vs-dropdown-item
                          v-if="
                            ((vistoria == true ||
                              item.dataVistoria ||
                              item.nomeStatus ==
                                STATUS_PROPOSTA.AGUARDANDO_APROVACAO.name ||
                              item.nomeStatus ==
                                STATUS_PROPOSTA.FINALIZADO.name ||
                              item.nomeStatus ==
                                STATUS_PROPOSTA.EM_PROCESSO_VISTORIA.name ||
                              item.nomeStatus ==
                                STATUS_PROPOSTA.PENDENTE.name) &&
                              $can('Visualizar Vistoria', subjectPermission)) ||
                            $can(
                              'Aprovar proposta sem vistoria',
                              subjectPermission,
                            )
                          "
                          divider
                          class="pt-2"
                          :to="`detalheVistoria/${item.idProposta}`"
                          data-testId="view-inspection-details-item"
                        >
                          <div class="flex gap-3">
                            <vs-icon
                              color="dark"
                              icon-pack="feather"
                              icon="icon-camera"
                            >
                            </vs-icon>
                            <span>Detalhes da Vistoria</span>
                          </div>
                        </vs-dropdown-item>
                        <vs-dropdown-item
                          v-if="
                            !isMicroLifePolicy(item.idTipoApolice) &&
                            hasPDF(item)
                          "
                          divider
                          class="pt-2"
                          target="_blank"
                          @click="openLinkContratoProposta(item)"
                          data-testId="microlife-download-proposal-contract-item"
                        >
                          <div class="flex gap-3">
                            <vs-icon
                              color="rgb(43,80,187)"
                              icon-pack="feather"
                              icon="icon-file-text"
                            >
                            </vs-icon>
                            <span>{{ getLabelContrato(item) }}</span>
                          </div>
                        </vs-dropdown-item>
                        <vs-dropdown-item
                          divider
                          class="pt-2"
                          @click="redirectVistoriaV2(item.chave, item.apolice)"
                          v-if="
                            !isLifeTypePolicy(item.idTipoApolice) &&
                            (item.id_Status ===
                              STATUS_PROPOSTA.EM_PROCESSO_VISTORIA.id ||
                              item.id_Status === STATUS_PROPOSTA.PENDENTE.id)
                          "
                          data-testId="redirect-inspection-item"
                        >
                          <div class="flex gap-3">
                            <vs-icon
                              color="warning"
                              icon-pack="feather"
                              icon="icon-external-link"
                            >
                            </vs-icon>
                            <span>Link da Vistoria</span>
                          </div>
                        </vs-dropdown-item>

                        <vs-dropdown-item
                          @click="goToCheckout(item.id_checkout)"
                          divider
                          class="pt-2"
                          v-if="
                            (isLifePolicy(item.idTipoApolice) &&
                              item.id_Status ===
                                STATUS_PROPOSTA.EM_TRANSMISSAO.id) ||
                            (isAutoPolicy(item.idTipoApolice) &&
                              item.id_Status ===
                                STATUS_PROPOSTA.AGUARDANDO_DADOS_CARTAO.id)
                          "
                          data-testId="redirect-checkout-item"
                        >
                          <div class="flex gap-3">
                            <vs-icon
                              color="warning"
                              icon-pack="feather"
                              icon="icon-send"
                            >
                            </vs-icon>
                            <span>Checkout</span>
                          </div>
                        </vs-dropdown-item>

                        <vs-dropdown-item
                          divider
                          class="pt-2"
                          @click="goToDocuments(item.chave)"
                          v-if="
                            isLifePolicy(item.idTipoApolice) &&
                            (item.id_Status ===
                              STATUS_PROPOSTA.AGUARDANDO_DOCUMENTACAO.id ||
                              item.id_Status === STATUS_PROPOSTA.PENDENTE.id)
                          "
                          data-testId="redirect-send-documents-item"
                        >
                          <div class="flex gap-3">
                            <vs-icon
                              color="warning"
                              icon-pack="feather"
                              icon="icon-external-link"
                            >
                            </vs-icon>
                            <span>Link Envio de Documentos</span>
                          </div>
                        </vs-dropdown-item>

                        <vs-dropdown-item
                          v-if="mostrarBotaoReabrirVistoria(item)"
                          divider
                          class="pt-2"
                          @click="reabrirVistoria(item)"
                          data-testId="reopen-inspection-item"
                        >
                          <div class="flex gap-3">
                            <vs-icon
                              color="rgb(187, 138, 200)"
                              icon-pack="feather"
                              icon="icon-refresh-cw"
                            >
                            </vs-icon>
                            <span>Reabrir Vistoria</span>
                          </div>
                        </vs-dropdown-item>

                        <vs-dropdown-item
                          v-if="
                            item.id_Status ===
                              STATUS_PROPOSTA.PROCESSANDO_PAGAMENTO.id &&
                            permissionReviewAntiFraud
                          "
                          divider
                          class="pt-2"
                          @click="openModalAntiFraud(item)"
                          data-testId="review-anti-fraud"
                        >
                          <div class="flex gap-3">
                            <vs-icon
                              color="warning"
                              icon-pack="feather"
                              icon="icon-credit-card"
                            >
                            </vs-icon>
                            <span>Analisar Pagamento</span>
                          </div>
                        </vs-dropdown-item>

                        <vs-dropdown-item
                          v-if="permissaoRecusar && mostrarBotaoRecusa(item)"
                          divider
                          class="pt-2"
                          @click="openModalRecusa(item)"
                          data-testId="refuse-proposal-item"
                        >
                          <div class="flex gap-3">
                            <vs-icon
                              color="danger"
                              icon-pack="feather"
                              icon="icon-minus"
                            >
                            </vs-icon>
                            <span>Recusar</span>
                          </div>
                        </vs-dropdown-item>

                        <vs-dropdown-item
                          v-if="
                            permissaoRecusaCorretora &&
                            mostrarBotaoRecusa(item) &&
                            mesmoDiaTransmitirProposta(item)
                          "
                          divider
                          class="pt-2"
                          @click="recusarCorretora(item)"
                          data-testId="refuse-broker-item"
                        >
                          <div class="flex gap-3">
                            <vs-icon
                              color="danger"
                              icon-pack="feather"
                              icon="icon-minus"
                            >
                            </vs-icon>
                            <span>Recusar {{ label(item) }}</span>
                          </div>
                        </vs-dropdown-item>

                        <vs-dropdown-item
                          v-if="
                            item.id_Status ==
                              STATUS_PROPOSTA.AGUARDANDO_ESTORNO.id &&
                            $can('Recusar', subjectPermission)
                          "
                          divider
                          class="pt-2"
                          @click="openModalConfirmaEstorno(item)"
                          data-testId="open-refund-popup-item"
                        >
                          <div class="flex gap-3">
                            <vs-icon
                              color="success"
                              icon-pack="feather"
                              icon="icon-dollar-sign"
                            >
                            </vs-icon>
                            <span>Confirmar Estorno</span>
                          </div>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
              <div v-if="vistoria" class="tagsInfo vx-col w-full">
                <div
                  @click="
                    openModalHistorico(
                      item.idProposta,
                      item.nomeStatus,
                      item.ultimaAlteracaoStatus || item.dataCotacao,
                    )
                  "
                  class="flex flex-wrap gap-1"
                  data-testId="open-historic-popup"
                >
                  <vs-chip
                    :color="getStatusColor(item.nomeStatus)"
                    class="divIdProposta rounded mb-4"
                  >
                    {{ item.nomeStatus }}
                  </vs-chip>
                  <vs-chip
                    v-if="
                      vistoria == true &&
                      (item.nomeStatus ==
                        STATUS_PROPOSTA.AGUARDANDO_APROVACAO.name ||
                        item.nomeStatus == STATUS_PROPOSTA.PENDENTE.name ||
                        item.nomeStatus == STATUS_PROPOSTA.FINALIZADO.name ||
                        item.nomeStatus == STATUS_PROPOSTA.EM_PRE_ANÁLISE.name)
                    "
                    :color="
                      getStatusColorHoras(
                        item.nomeStatus,
                        item.ultimaAlteracaoStatus || item.dataCotacao,
                      )
                    "
                    class="divIdProposta rounded mb-4"
                  >
                    <feather-icon
                      icon="ClockIcon"
                      class="mr-2"
                      svgClasses="stroke-current w-6 h-6"
                    />

                    <span v-if="item.nomeStatus !== 'Em Pré-Análise'">{{
                      calculaQtddeDiasEnviada(
                        item.nomeStatus,
                        item.ultimaAlteracaoStatus || item.dataCotacao,
                      )
                    }}</span>
                    <span v-if="item.nomeStatus === 'Em Pré-Análise'"
                      >{{
                        calculaQtddeDiasEnviada(
                          item.nomeStatus,
                          item.ultimaAlteracaoStatus || item.dataCotacao,
                        )
                      }}
                      do total de 12h</span
                    >
                  </vs-chip>
                  <vs-chip
                    v-if="
                      item.qtdRecusa > 0 &&
                      vistoria == true &&
                      item.nomeStatus ==
                        STATUS_PROPOSTA.AGUARDANDO_APROVACAO.name
                    "
                    color="#FF6347"
                    class="divIdProposta rounded mb-4"
                  >
                    <feather-icon
                      icon="AlertTriangleIcon"
                      class="mr-2"
                      svgClasses="stroke-current w-6 h-6"
                    />
                    Retorno de Pendência
                  </vs-chip>

                  <vs-chip
                    v-if="
                      item.nomeStatus == 'Finalizada' &&
                      item.sincronizacaoSga == false &&
                      item.dataSincronizacaoSga != null
                    "
                    class="divIdPropostarounded mb-4"
                    color="danger"
                    >Necessário Resync
                  </vs-chip>
                </div>
              </div>
              <transition name="slide">
                <div v-if="item.expandeDetalhes" class="vx-col w-full">
                  <div class="w-full flex justify-center mb-3">
                    <hr class="hrDetalhes mt-2" />
                  </div>
                  <div class="sm:flex gap-6 w-full mt-3">
                    <div class="flex gap-2 mb-2">
                      <vs-icon
                        :icon="iconeTipoVeiculo(item.codTipoVeiculo)"
                        size="small"
                        color="#374957"
                      ></vs-icon>
                      <div>
                        <p class="divSubTitle">Placa: {{ item.placa }}</p>
                        <p class="divInfo">Grupo: {{ item.nomeGrupo }}</p>
                      </div>
                    </div>
                    <div class="flex gap-2 mb-2">
                      <vs-icon
                        icon="description"
                        size="small"
                        color="#374957"
                      ></vs-icon>
                      <p class="divSubTitle">
                        {{ item.veiculoMarca }} {{ item.veiculoModelo }}
                      </p>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </vs-card>
          <div
            class="expandirCotacoes vx-col"
            v-if="!isLifeTypePolicy(item.idTipoApolice)"
          >
            <vs-button
              color="#E9E9E9"
              text-color="#374957"
              :icon="item.expandeDetalhes ? 'expand_less' : 'expand_more'"
              icon-after
              class="w-full buttonExpandirCotacoes z-0 text-base font-semibold"
              @click="item.expandeDetalhes = !item.expandeDetalhes"
              data-testId="expand-button"
              >{{ item.expandeDetalhes ? 'Recolher' : 'Expandir' }}
            </vs-button>
          </div>
        </div>
      </div>
    </div>
    <vs-card>
      <vs-pagination
        :max="screenWidth < 650 ? 5 : 9"
        v-if="qtdPaginas"
        :total="qtdPaginas"
        v-model="paginaAtual"
        data-testId="pagination-button"
      ></vs-pagination>
    </vs-card>

    <ModalRefuseProposal
      :policyId="formRecusa.idApolice"
      :policyTypeId="formRecusa.idTipoApolice"
      @handleProposalRefused="buscaDados"
      :active="popRecusa"
      @close="popRecusa = false"
    />

    <ModalAntiFraud
      :policyId="idApolice"
      :active="popAntiFraud"
      @close="popAntiFraud = false"
    />
    <Modal
      class="holamundo"
      :title="'Confirmar Estorno'"
      :active.sync="popConfirmaEstorno"
      @close="popConfirmaEstorno = false"
      data-testId="confirm-refund-popup"
    >
      <label for="" class="vs-datepicker--label">Data do Estorno</label>
      <datepicker
        name="Data do Estorno"
        id="Data do Estorno"
        :format="'dd/MM/yyyy'"
        placeholder="DD/MM/YYYY"
        v-model="formConfirmaEstorno.refundDate"
        v-validate="{ required: true }"
        :state="validateState('Data do Estorno')"
        :class="validateClass('Data do Estorno')"
        data-testId="refund-date-datepicker"
      ></datepicker>

      <label for="" class="vs-input--label">Valor do Estorno</label>
      <money
        class="w-full vs-inputx vs-input--input normal"
        name="Valor do Estorno"
        id="Valor do Estorno"
        v-model="formConfirmaEstorno.refundValue"
        v-validate="{ required: true, min_value: 0 }"
        v-bind="money"
        :state="validateState('Valor do Estorno')"
        :danger="validateClass('Valor do Estorno')"
        data-testId="refund-value-input"
      ></money>

      <vs-button
        @click="confirmRefund()"
        color="success"
        class="mb-2 my-5 ml-2"
        data-testId="refusal-reason-popup-save-button"
      >
        <span>Salvar</span>
      </vs-button>
    </Modal>

    <!------------ START INFORMAÇÕES DO Proposta ------------>
    <Modal
      v-if="modalSelecionado != {}"
      class="holamundo"
      :title="'Detalhes da Proposta'"
      :active.sync="popupActive"
      @close="closePop"
      data-testId="proposal-details-popup"
    >
      <table class="table table-bordered">
        <tr>
          <th class="uppercase">Código da Proposta</th>
          <td>{{ modalSelecionado.idProposta }}</td>
        </tr>
        <tr>
          <th class="uppercase">Apólice</th>
          <td>{{ getApolicesTagText(modalSelecionado.idTipoApolice) }}</td>
        </tr>
        <tr>
          <th class="uppercase">Tipo</th>
          <td>{{ modalSelecionado.tipoProposta }}</td>
        </tr>
        <tr>
          <th class="uppercase">Status</th>
          <td>{{ modalSelecionado.nomeStatus }}</td>
        </tr>
        <tr v-if="modalSelecionado.motivoRecusa">
          <th class="uppercase">Motivo Recusa</th>
          <td>{{ modalSelecionado.motivoRecusa }}</td>
        </tr>
        <tr v-if="modalSelecionado.obsRecusa">
          <th class="uppercase">Obs. Recusa</th>
          <td>{{ modalSelecionado.obsRecusa }}</td>
        </tr>
        <tr v-if="modalSelecionado.createdAt">
          <th class="uppercase">Data da Cotação</th>
          <td>
            {{ functions.formatDateAndHour(modalSelecionado.createdAt) }}
          </td>
        </tr>
        <tr v-if="modalSelecionado.proposalDate">
          <th class="uppercase">Data da Proposta</th>
          <td>
            {{ functions.formatDateAndHour(modalSelecionado.proposalDate) }}
          </td>
        </tr>
        <tr
          v-if="
            modalSelecionado.dataVistoria &&
            !isLifeTypePolicy(modalSelecionado.idTipoApolice)
          "
        >
          <th class="uppercase">Data da Vistoria</th>
          <td>
            {{ functions.formatDateAndHour(modalSelecionado.dataVistoria) }}
          </td>
        </tr>
        <tr
          v-if="
            modalSelecionado.dataVistoria &&
            isLifeTypePolicy(modalSelecionado.idTipoApolice)
          "
        >
          <th class="uppercase">Data Envio da Documentação</th>
          <td>
            {{ functions.formatDateAndHour(modalSelecionado.dataVistoria) }}
          </td>
        </tr>
        <tr>
          <th class="uppercase">Origem</th>
          <td>{{ modalSelecionado.origem }}</td>
        </tr>
        <tr
          v-if="
            modalSelecionado.cotaTabela &&
            !isLifeTypePolicy(modalSelecionado.idTipoApolice)
          "
        >
          <th class="uppercase">Faixa Tabela</th>
          <td>{{ modalSelecionado.cotaTabela }}</td>
        </tr>
        <tr v-if="modalSelecionado.restricaoDescricao">
          <th class="uppercase">Motivo Recusa</th>
          <td class="bg-danger text-white p-2">
            {{ modalSelecionado.restricaoDescricao }}
          </td>
        </tr>
        <tr v-if="modalSelecionado.observacao">
          <th class="uppercase">Observação</th>
          <td>{{ modalSelecionado.observacao }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVendedor">
          <th class="uppercase">Corretora</th>
          <td>
            Corretora:
            {{ modalSelecionado.regional }} / Assessoria:
            {{ modalSelecionado.nomeDivisao }}
          </td>
        </tr>
        <tr v-if="modalSelecionado.cupom">
          <th class="uppercase">Cupom Utilizado</th>
          <td>
            {{ modalSelecionado.cupom }}
          </td>
        </tr>
      </table>
      <hr class="my-2" />
      <h5 class="my-2">Dados do Segurado</h5>
      <table class="table table-bordered" v-if="modalSelecionado.dadosCliente">
        <tr>
          <th class="uppercase">Nome / Nome Social</th>
          <td>{{ modalSelecionado.dadosCliente.associado }}</td>
        </tr>
        <tr>
          <th class="uppercase">Nome Social?</th>
          <td>
            {{
              modalSelecionado.dadosCliente.associadoNomeSocial ? 'Sim' : 'Não'
            }}
          </td>
        </tr>
        <tr v-if="modalSelecionado.dadosCliente.associadoNomeSocial">
          <th class="uppercase">Nome Civil</th>
          <td>{{ modalSelecionado.dadosCliente.associadoNomeCivil }}</td>
        </tr>
        <tr>
          <th class="uppercase">Email</th>
          <td>{{ modalSelecionado.dadosCliente.email }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosCliente.telefone">
          <th class="uppercase">Telefone</th>
          <td>{{ modalSelecionado.dadosCliente.telefone }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosCliente.celular">
          <th class="uppercase">Celular</th>
          <td>{{ modalSelecionado.dadosCliente.celular }}</td>
        </tr>
        <tr>
          <th class="uppercase">Endereço</th>
          <td>
            {{ modalSelecionado.dadosCliente.cep }}
            <br />
            {{ modalSelecionado.dadosCliente.endereco }}
            {{ modalSelecionado.dadosCliente.numero }}
            {{ modalSelecionado.dadosCliente.complemento }}
            <br />
            {{ modalSelecionado.dadosCliente.bairro }}
            <br />
            {{ modalSelecionado.dadosCliente.cidade }} /
            {{ modalSelecionado.dadosCliente.estado }}
          </td>
        </tr>
        <tr>
          <th class="uppercase">Tipo</th>
          <td>{{ modalSelecionado.dadosCliente.tipo }}</td>
        </tr>
        <tr>
          <th class="uppercase">CPF/CNPJ</th>
          <td>{{ modalSelecionado.dadosCliente.cpf }}</td>
        </tr>
      </table>
      <div v-if="!isLifeTypePolicy(modalSelecionado.idTipoApolice)">
        <hr class="my-2" />
        <h5 class="my-2">Dados do Veiculo</h5>
        <table
          class="table table-bordered"
          v-if="modalSelecionado.dadosVeiculo"
        >
          <tr v-if="modalSelecionado.isZero">
            <th class="uppercase">Zero KM</th>
            <td>
              NF: {{ modalSelecionado.nf }}
              <br />
              Data: {{ formataDataUTC(modalSelecionado.dataNf) }}
            </td>
          </tr>
          <tr v-if="modalSelecionado.nomeGrupo">
            <th class="uppercase">Grupo</th>
            <td>{{ modalSelecionado.nomeGrupo }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.veiculoMarca">
            <th class="uppercase">Marca</th>
            <td>{{ modalSelecionado.dadosVeiculo.veiculoMarca }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.veiculoModelo">
            <th class="uppercase">Modelo</th>
            <td>{{ modalSelecionado.dadosVeiculo.veiculoModelo }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.anoFabricacao">
            <th class="uppercase">Ano</th>
            <td>
              {{
                modalSelecionado.dadosVeiculo.anoFabricacao == '32000'
                  ? '0Km'
                  : `${modalSelecionado.dadosVeiculo.anoFabricacao} / ${modalSelecionado.dadosVeiculo.anoModelo}`
              }}
            </td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.placa">
            <th class="uppercase">Placa</th>
            <td>{{ modalSelecionado.dadosVeiculo.placa }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.tipoCambio">
            <th class="uppercase">Tipo de Câmbio</th>
            <td>{{ modalSelecionado.dadosVeiculo.tipoCambio }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.numeroMotor">
            <th class="uppercase">Número do Motor</th>
            <td>{{ modalSelecionado.dadosVeiculo.numeroMotor }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.renavam">
            <th class="uppercase">Renavam</th>
            <td>{{ modalSelecionado.dadosVeiculo.renavam }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.chassi">
            <th class="uppercase">Chassi</th>
            <td>{{ modalSelecionado.dadosVeiculo.chassi }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.combustivel">
            <th class="uppercase">Combustivel</th>
            <td>{{ modalSelecionado.dadosVeiculo.combustivel }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.cilindradas">
            <th class="uppercase">Cilindrada</th>
            <td>{{ modalSelecionado.dadosVeiculo.cilindradas }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.codigoFipe">
            <th class="uppercase">Codigo Fipe</th>
            <td>{{ modalSelecionado.dadosVeiculo.codigoFipe }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.cor">
            <th class="uppercase">Cor</th>
            <td>{{ modalSelecionado.dadosVeiculo.cor }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.estadoPneu">
            <th class="uppercase">Estado do Pneu</th>
            <td>{{ modalSelecionado.dadosVeiculo.estadoPneu }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.km">
            <th class="uppercase">km</th>
            <td>{{ modalSelecionado.dadosVeiculo.km }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.valorFipe">
            <th class="uppercase">Valor</th>
            <td>{{ modalSelecionado.dadosVeiculo.valorFipe | currency }}</td>
          </tr>
          <tr v-if="modalSelecionado.dadosVeiculo.valorCobertura">
            <th class="uppercase">Valor Cobertura</th>
            <td>
              {{ modalSelecionado.dadosVeiculo.valorCobertura | currency }}
            </td>
          </tr>
          <tr v-if="franquiaCasco">
            <th class="uppercase">Valor da Franquia</th>
            <td>{{ franquiaCasco | currency }}</td>
          </tr>
          <!-- <tr v-if="modalSelecionado.valorParticipacaoMinimo">
            <th class="uppercase">Valor Mínimo de Participação</th>
            <td>{{ modalSelecionado.valorParticipacaoMinimo | currency }}</td>
          </tr> -->
          <tr v-if="modalSelecionado.restricoes.length > 0">
            <th class="uppercase">Restrições</th>
            <td>
              <p v-for="item in modalSelecionado.restricoes" :key="item.id">
                {{ item.descricao }}
              </p>
            </td>
          </tr>
        </table>
      </div>
      <div v-if="!isLifeTypePolicy(modalSelecionado.idTipoApolice)">
        <hr class="my-2" />
        <h5 class="my-2">Produtos</h5>
        <table class="table table-bordered" v-if="modalSelecionado.produtos">
          <tr v-if="modalSelecionado.produtos.length > 0">
            <th class="uppercase">Produtos</th>
            <td>
              <p v-for="item in modalSelecionado.produtos" :key="item.id">
                {{ item.productName }}
                <span class="valorprod mr-2" v-if="!item.isService">
                  ( {{ functions.formataReal(item.prize.prize) }} )
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <th class="uppercase">Valor Total</th>
            <td>
              {{ functions.formataReal(totalProductsPrize) }}
            </td>
          </tr>
          <!-- <tr>
            <th class="uppercase">Valor Entrada</th>
            <td>{{ somaValorTotal(modalSelecionado.produtos) | currency }}</td>
          </tr> -->
        </table>
      </div>
      <div v-if="isLifePolicy(modalSelecionado.idTipoApolice)">
        <hr class="my-2" />
        <h5 class="my-2">Produtos</h5>
        <table class="table table-bordered" v-if="modalSelecionado.produtos">
          <tr v-if="modalSelecionado.produtosVida.details.length > 0">
            <th class="uppercase">Produtos</th>
            <td>
              <p
                v-for="item in modalSelecionado.produtosVida.details"
                :key="item.id"
              >
                {{ item.name }} - {{ item.prize.insured_value | currency }} ({{
                  (item.prize.prize / 12) | currency
                }}
                / mês)
              </p>
            </td>
          </tr>
          <tr>
            <th class="uppercase">Valor Anual</th>
            <td>
              {{ modalSelecionado.produtosVida.prize | currency }}
            </td>
          </tr>
          <!-- <tr>
            <th class="uppercase">Valor Entrada</th>
            <td>{{ somaValorTotal(modalSelecionado.produtos) | currency }}</td>
          </tr> -->
        </table>
      </div>

      <!-- dados agregados -->
      <hr
        v-if="modalSelecionado.agregado && modalSelecionado.agregados"
        class="mt-8"
      />
      <div v-if="modalSelecionado.agregado && modalSelecionado.agregados">
        <div
          v-for="(agregado, index) in modalSelecionado.agregados"
          :key="index"
        >
          <h5
            v-if="
              modalSelecionado.agregado && modalSelecionado.agregados.length > 0
            "
            class="my-6"
          >
            Agregado - {{ agregado.placa || agregado.chassi }} |
            {{ agregado.descricao }}
          </h5>
          <table
            class="table table-bordered"
            v-if="modalSelecionado.dadosVeiculo"
          >
            <tr v-if="agregado.nomeGrupo">
              <th class="uppercase">Grupo</th>
              <td>{{ agregado.nomeGrupo }}</td>
            </tr>
            <tr v-if="agregado.descricao">
              <th class="uppercase">Descrição</th>
              <td>{{ agregado.descricao }}</td>
            </tr>
            <tr v-if="agregado.marca">
              <th class="uppercase">Marca</th>
              <td>{{ agregado.marca }}</td>
            </tr>
            <tr v-if="agregado.modelo">
              <th class="uppercase">Modelo</th>
              <td>{{ agregado.modelo }}</td>
            </tr>

            <tr v-if="agregado.placa">
              <th class="uppercase">Placa</th>
              <td>{{ agregado.placa }}</td>
            </tr>
            <tr v-if="agregado.chassi">
              <th class="uppercase">Chassi</th>
              <td>{{ agregado.chassi }}</td>
            </tr>
            <tr v-if="agregado.valorCobertura">
              <th class="uppercase">Valor Cobertura</th>
              <td>
                {{ agregado.valorCobertura | currency }}
              </td>
            </tr>
            <tr v-if="agregado.porcentagemParticipacao">
              <th class="uppercase">Valor Cota de Participação</th>
              <td>{{ agregado.porcentagemParticipacao }} %</td>
            </tr>
            <tr v-if="agregado.valorMinimoParticipacao">
              <th class="uppercase">Valor Mínimo de Participação</th>
              <td>{{ agregado.valorMinimoParticipacao | currency }}</td>
            </tr>
          </table>
          <hr class="my-2" />
          <h5 class="my-2">Produtos</h5>
          <table class="table table-bordered" v-if="agregado.produtosAgregado">
            <tr v-if="agregado.produtosAgregado.length > 0">
              <th class="uppercase">Produtos</th>
              <td>
                <p
                  v-for="item in agregado.produtosAgregado"
                  :key="item.idProduto"
                >
                  {{ item.nomeProduto }}
                  <span
                    v-if="item.descontoConcedido > 0"
                    :style="'text-decoration: line-through;'"
                    class="mr-2"
                    >{{ item.valor | currency }}</span
                  >
                  <span class="valorprod mr-2"
                    >( {{ item.valorFinal | currency }}
                    <span v-if="item.isMensal == true">/mês</span>)</span
                  >
                </p>
              </td>
            </tr>
            <tr>
              <th class="uppercase">Valor Mensal</th>
              <td>
                {{ somaValorTotalMes(agregado.produtosAgregado) | currency }}
              </td>
            </tr>
            <tr>
              <th class="uppercase">Valor à Vista</th>
              <td>
                {{ somaValorTotal(agregado.produtosAgregado) | currency }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- dados implementos -->
      <hr
        v-if="modalSelecionado.implemento && modalSelecionado.implementos"
        class="mt-8"
      />
      <div v-if="modalSelecionado.implemento && modalSelecionado.implementos">
        <div
          v-for="(implemento, index) in modalSelecionado.implementos"
          :key="index"
        >
          <h5
            v-if="
              modalSelecionado.implemento &&
              modalSelecionado.implementos.length > 0
            "
            class="my-6"
          >
            Implemento -
            {{ implemento.placa || implemento.chassi || '' }}
            {{ implemento.descricao }}
          </h5>
          <table
            class="table table-bordered"
            v-if="modalSelecionado.dadosVeiculo"
          >
            <tr v-if="implemento.nomeGrupo">
              <th class="uppercase">Grupo</th>
              <td>{{ implemento.nomeGrupo }}</td>
            </tr>
            <tr v-if="implemento.descricao">
              <th class="uppercase">Descrição</th>
              <td>{{ implemento.descricao }}</td>
            </tr>
            <tr v-if="implemento.marca">
              <th class="uppercase">Marca</th>
              <td>{{ implemento.marca }}</td>
            </tr>
            <tr v-if="implemento.modelo">
              <th class="uppercase">Modelo</th>
              <td>{{ implemento.modelo }}</td>
            </tr>

            <tr v-if="implemento.placa">
              <th class="uppercase">Placa</th>
              <td>{{ implemento.placa }}</td>
            </tr>
            <tr v-if="implemento.chassi">
              <th class="uppercase">Chassi</th>
              <td>{{ implemento.chassi }}</td>
            </tr>
            <tr v-if="implemento.valorCobertura">
              <th class="uppercase">Valor Cobertura</th>
              <td>
                {{ implemento.valorCobertura | currency }}
              </td>
            </tr>
            <tr v-if="implemento.porcentagemParticipacao">
              <th class="uppercase">Valor Cota de Participação</th>
              <td>{{ implemento.porcentagemParticipacao }} %</td>
            </tr>
            <tr v-if="implemento.valorMinimoParticipacao">
              <th class="uppercase">Valor Mínimo de Participação</th>
              <td>{{ implemento.valorMinimoParticipacao | currency }}</td>
            </tr>
          </table>
          <hr />
        </div>
      </div>
    </Modal>

    <div
      class="tooltip vue-tooltip-theme"
      role="tooltip"
      id="tooltip_i49mvvi0bs"
      aria-hidden="true"
      x-placement="top"
      style="
        position: absolute;
        will-change: transform;
        top: 0px;
        left: 0px;
        transform: translate3d(1492px, 433px, 0px);
        display: none;
      "
    >
      <div class="tooltip-arrow" style="left: 0px"></div>
      <div class="tooltip-inner">Detalhes da Proposta</div>
    </div>

    <div class="centerx">
      <Modal
        :fullscreen="false"
        title=""
        @close="modalConfirmacaoResponsavelVistoria = false"
        :active.sync="modalConfirmacaoResponsavelVistoria"
        data-testId="inspection-responsible-popup-main"
      >
        <div class="vx-row">
          <div class="mx-auto">
            <div class="vx-col w-full text-center">
              <p class="mb-5 text-xl">
                Deseja assumir a responsabilidade pela análise desta vistoria?
              </p>
              <vs-button
                @click="modalConfirmacaoResponsavelVistoria = false"
                type="gradient"
                color="dark"
                class="mt-5"
                style="margin-right: 5px"
                data-testId="inspection-responsible-cancel-button-main"
              >
                <feather-icon
                  class="text-white"
                  icon="CheckIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
                Cancelar
              </vs-button>
              <vs-button
                @click="tornarResponsavelVistoria(id_usuario)"
                type="gradient"
                color="success"
                class="mt-5"
                data-testId="inspection-responsible-confirm-button-main"
              >
                <feather-icon
                  class="text-white"
                  icon="CheckIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
                Confirmar
              </vs-button>
            </div>
          </div>
        </div>
      </Modal>
    </div>

    <!-- modal assumir vistoria -->
    <div class="centerx">
      <Modal
        :fullscreen="true"
        title="Responsavel pela análise de Cadastro"
        @close="
          (modalResponsavelVistoria = false),
            (consultorAnaliseSelecionado = null)
        "
        :active.sync="modalResponsavelVistoria"
        data-testId="inspection-responsible-popup"
      >
        <div class="vx-row">
          <div class="mx-auto" style="padding: 12.5rem 1.25rem 25rem 1.25rem">
            <div class="vx-col w-full">
              <div v-if="$can('Editar Responsável Vistoria', 'Vistorias')">
                <p class="mb-5">
                  Selecione o responsável pela vistoria. Apenas o responsável
                  poderá aprovar ou reprovar a vistoria e as fotos. Clique em
                  sim para confirmar.
                </p>
                <span>Corretor</span>
                <v-select
                  :options="colaboradoresCadastro"
                  name="Responsavel pela análise de Cadastro"
                  label="label"
                  id="idUsuarioResponsavelCadastro"
                  v-model="consultorAnaliseSelecionado"
                  class="select-large w-full"
                  :reduce="(item) => item.id"
                  data-testId="inspection-responsible-select"
                ></v-select>
              </div>
              <div v-else>
                <p class="mb-5">
                  Esta ação fará com que você se torne o responsável pela
                  vistoria dessa cotação. Apenas você poderá aprovar ou reprovar
                  a vistoria e as fotos da vistoria. Quer continuar?
                </p>
              </div>
            </div>
            <div class="vx-col w-full text-right">
              <vs-button
                @click="
                  (modalResponsavelVistoria = false),
                    (consultorAnaliseSelecionado = null)
                "
                type="gradient"
                color="success"
                class="mt-5"
                style="margin-right: 5px"
                data-testId="inspection-responsible-cancel-button"
              >
                <feather-icon
                  class="text-white"
                  icon="CheckIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
                Não
              </vs-button>
              <vs-button
                @click="tornarResponsavelVistoria(consultorAnaliseSelecionado)"
                type="gradient"
                color="success"
                class="mt-5"
                data-testId="inspection-responsible-confirm-button"
              >
                <feather-icon
                  class="text-white"
                  icon="CheckIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
                Sim
              </vs-button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
    <!------------ END INFORMAÇÕES DO Proposta ------------>
  </div>
</template>

<script>
import jwt from 'jsonwebtoken';
import moment from 'moment';
import { Money } from 'v-money';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import Modal from '../../components/Modal.vue';
import {
  POLICY_CREATION_TYPE,
  PRODUCT_NAME,
  PRODUCT_TAG,
} from '../../constants/tipo.apolice';
import service from '../../services';
import autoApi from '../../services/auto.api';
import { calcularFranquia } from '../../services/cotacao';
import lifeService from '../../services/life-api';
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import ModalHistorico from '../modais/ModalHistorico.vue';
import ModalRefuseProposal from '../modais/ModalRefuseProposal.vue';
import ModalAntiFraud from '../modais/ModalAntiFraud.vue';
import {
  DATE_TYPES,
  ID_MOTIVO_RECUSA_CORRETORA_PADRAO,
  POLICY_STATUSES,
  STATUS_PROPOSTA,
  TIPOS_APOLICES,
  URL_CHECKOUT,
  URL_DOCUMENTOS_VIDA,
  URL_VISTORIA,
  URL_VISTORIA_VIDA,
} from './../../utils/constants';

export default {
  components: {
    vSelect,
    ModalHistorico,
    Datepicker,
    Money,
    Modal,
    ModalRefuseProposal,
    ModalAntiFraud,
  },
  props: [
    'filtro',
    'realizaFiltro',
    'vistoria',
    'subjectPermission',
    'propColaboradoresCadastro',
  ],
  watch: {
    realizaFiltro: function (newValue) {
      if (newValue == true) {
        const currentPage = this.paginaAtual;

        if (currentPage !== 1) {
          this.paginaAtual = 1;
        } else {
          this.buscaDados();
        }

        this.$emit('filtroOk', true);
      }
    },
    paginaAtual: function () {
      this.buscaDados();
    },
    itemsPerPage: function () {
      this.buscaDados();
    },
    propColaboradoresCadastro: function (value) {
      if (value) {
        this.colaboradoresCadastro = value;
      }
    },
  },
  data() {
    return {
      STATUS_PROPOSTA,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
      },
      functions: functions,
      colaboradoresCadastro: [],
      modalConfirmacaoResponsavelVistoria: false,
      modalResponsavelVistoria: false,
      chave: 0,
      isAdmin: false,
      idEmpresa: null,
      dadosSideBar: {},
      formRecusa: {
        idProposta: null,
        idApolice: null,
        obsRecusa: null,
        idMotivoRecusa: null,
        idTipoApolice: null,
      },
      formConfirmaEstorno: {
        refundDate: new Date().toISOString(),
        refundValue: 0,
        idTipoApolice: null,
        idApolice: null,
      },
      controllerGeral: 'Proposta',
      formSideBar: 'Proposta',
      entidade: 'Proposta',
      titleSideBar: 'Adicionar Proposta',
      popupActive: false,
      popRecusa: false,
      popAntiFraud: false,
      idApolice: null,
      popConfirmaEstorno: false,
      modalSelecionado: {},
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 50,
      paginaAtual: 1,
      qtdTotal: 0,
      qtdPaginas: 0,
      isMounted: false,
      addNewDataSidebar: false,
      exibir: false,
      regionais: [],
      regionaisUsuario: [],
      regionalDefault: [],
      usuarios_regionais: [],
      idRegionais: [],
      idProposta: null,
      nomeUsuario: '',
      consultorAnaliseSelecionado: null,
      id_usuario: null,
      dadosHistorico: {},
      isConsultor: null,
      screenWidth: null,
      filtroDiasAnteriores: 30,
      PRODUCT_NAME,
      totalProductsPrize: 0,
      listSetores: [],
    };
  },
  computed: {
    POLICY_STATUSES() {
      return POLICY_STATUSES;
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    // SEGURADORA
    franquiaCasco() {
      const { produtos } = calcularFranquia(this.modalSelecionado);

      let totalCasco = 0;

      produtos.forEach(({ franquia }) => {
        totalCasco += franquia;
      });

      return totalCasco;
    },
    permissaoRecusar() {
      return this.$can('Recusar', this.subjectPermission);
    },
    permissaoRecusaCorretora() {
      return this.$can('Recusa Corretora', this.subjectPermission);
    },
    permissionReviewAntiFraud() {
      return this.$can('Escrita', 'Analise de Pagamento');
    },
  },

  methods: {
    isCotacao(item) {
      return [
        STATUS_PROPOSTA.COTACAO_ABERTA.id,
        STATUS_PROPOSTA.COTACAO_CANCELADA.id,
        STATUS_PROPOSTA.COTACAO_RECUSADA.id,
        STATUS_PROPOSTA.EM_TRANSMISSAO.id,
      ].includes(item.id_Status);
    },
    label(item) {
      return this.isCotacao(item) ? 'Cotação' : 'Proposta';
    },
    cotacaoLabel(data) {
      return data === STATUS_PROPOSTA.COTACAO_CANCELADA.name ||
        data === STATUS_PROPOSTA.COTACAO_RECUSADA.name
        ? 'Detalhes da Cotação'
        : 'Editar Cotação';
    },
    mostrarBotaoRecusa(item) {
      return (
        item.nomeStatus !== STATUS_PROPOSTA.COTACAO_CANCELADA.name &&
        item.nomeStatus !== STATUS_PROPOSTA.COTACAO_RECUSADA.name &&
        item.nomeStatus !== STATUS_PROPOSTA.RECUSADA.name &&
        item.nomeStatus !== STATUS_PROPOSTA.FINALIZADO.name &&
        item.nomeStatus !== STATUS_PROPOSTA.AGUARDANDO_ESTORNO.name &&
        item.nomeStatus !== STATUS_PROPOSTA.ESTORNADA.name
      );
    },
    mesmoDiaTransmitirProposta(item) {
      if (!item.proposal_date) {
        return true;
      }

      const proposalDate = new Date(item.proposal_date.replace('Z', ''));
      const hoje = new Date();

      const mesmoDia =
        proposalDate.getFullYear() === hoje.getFullYear() &&
        proposalDate.getMonth() === hoje.getMonth() &&
        proposalDate.getDate() === hoje.getDate();

      return mesmoDia;
    },
    recusarCorretora(item) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirmar`,
        text: 'Tem certeza que deseja cancelar esta cotação/proposta? Essa ação é irreversível.',
        acceptText: 'Confirmar',
        cancelText: 'Cancelar',
        accept: () => this.recusar(item),
      });
    },
    recusar(item) {
      this.formRecusa = {
        idApolice: item.apolice_id,
        obsRecusa: null,
        idMotivoRecusa: ID_MOTIVO_RECUSA_CORRETORA_PADRAO,
      };

      const controller = 'auto';
      const action = 'refuse/' + this.formRecusa.idApolice;
      const data = {
        reasonId: this.formRecusa.idMotivoRecusa,
        description: this.formRecusa.obsRecusa,
      };

      this.$vs.loading();
      lifeService.update(controller, data, action).then(async () => {
        this.formRecusa.idApolice = null;
        this.formRecusa.idMotivoRecusa = null;
        this.formRecusa.obsRecusa = null;
        await this.buscaDados();
        notify.notifySuccess(
          this.$vs,
          `${this.label(item)} cancelada com sucesso!`,
        );
        this.$vs.loading.close();
      });
    },
    linkMenuEditar(item) {
      if (item.creationType === 'ENDORSEMENT') {
        return `auto/apolice/${item.policyNumber}/endosso`;
      }

      if (item.idTipoApolice === TIPOS_APOLICES.RCVAT) {
        return `editarCotacao2/${item.idProposta}`;
      }

      const isAlreadyTransmitted = functions.isAlreadyTransmitted(
        item.id_Status,
      );

      if (
        !isAlreadyTransmitted &&
        item.id_Status !== STATUS_PROPOSTA.EM_TRANSMISSAO.id
      ) {
        return `auto/cotacao/${item.idProposta}`;
      }

      return `auto/proposta/${item.idProposta}`;
    },
    isLifeTypePolicy(idTipoApolice) {
      return (
        idTipoApolice == TIPOS_APOLICES.VIDA ||
        idTipoApolice == TIPOS_APOLICES.MICRO_VIDA
      );
    },
    isLifePolicy(idTipoApolice) {
      return idTipoApolice == TIPOS_APOLICES.VIDA;
    },
    isMicroLifePolicy(idTipoApolice) {
      return idTipoApolice == TIPOS_APOLICES.MICRO_VIDA;
    },
    isAutoPolicy(idTipoApolice) {
      return idTipoApolice == TIPOS_APOLICES.AUTO;
    },
    goToCheckout(idCheckout) {
      window.open(`${URL_CHECKOUT}/vida/${idCheckout}`, '_blank');
    },
    goToDocuments(chave) {
      window.open(`${URL_DOCUMENTOS_VIDA}/documentos/${chave}`, '_blank');
    },
    returnLinkWhats(item) {
      let linkRelativo = window.location.origin;
      if (item.nome && item.celular ? item.celular : item.telefone) {
        var nome = item.nome.split(' ')[0];
        var celular = item.celular
          ? item.celular
          : item.telefone
              .replace('(', '')
              .replace(')', '')
              .replace(' ', '')
              .replace('-', '');
        var texto = `Olá ${nome}, tudo bem? A cotação da ${item.empresa} para proteger seu veículo foi gerada, você consegue aceita-la e fazer sua vistoria tudo por lá, acesse ${linkRelativo}/proposta/${item.chave}`;
        var textoEncode = encodeURI(texto);

        var link = '';
        //if (isBrowser == true)
        link = `https://api.whatsapp.com/send?phone=55${celular}&text=${textoEncode}`;
        //else link = `whatsapp://send?phone=55${celular}&text=${textoEncode}`;

        return link;
      } else return null;
    },
    verificaAdmin() {
      const token = localStorage.getItem('user-token');

      if (token) {
        const decoded = jwt.decode(token);
        if (decoded.nomePerfil == 'Super User') this.isAdmin = true;
      }

      const decoded = jwt.decode(token);

      this.id_usuario = decoded.id_usuario;
      this.nomeUsuario = decoded.nome;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref) ? 'has-error' : '';
      }
      return null;
    },
    novaProposta() {
      this.$router.push('/auto/cotacao');
    },
    somaValorTotalMes(produtos) {
      var total = 0;
      produtos.forEach((element) => {
        total = total + element.prize.prize;
      });
      return functions.formataReal(total);
    },

    calculaQtddeDiasEnviada(status, date) {
      if (status === 'Finalizada') {
        return moment(date).format('DD/MM/YYYY HH:mm:ss');
      }

      const horas = moment().diff(date, 'hours');

      if (status == 'Em Pré-Análise') return horas + 'h';

      const ms = moment().diff(moment(date));
      return functions.formataMsParaData(ms);
    },

    getStatusColorHoras(status, date) {
      const a = moment();
      const horas = a.diff(date, 'hours');

      if (status === 'Finalizada') return 'dark';

      if (status === 'Em Pré-Análise') {
        if (horas < 4) return 'success';
        if (horas >= 4 && horas <= 8) return 'warning';
        if (horas > 8) return 'danger';
      }

      if (horas < 10) return 'success';
      if (horas >= 10 && horas <= 24) return 'warning';
      if (horas > 24) return 'danger';
    },
    somaValorTotal(produtos) {
      var total = 0;
      produtos.forEach((element) => {
        if (element.isMensal != true) total = total + element.valorFinal;
      });
      return total;
    },
    closePop() {
      this.popupActive = false;
    },
    closeSideBar() {
      this.addNewDataSidebar = false;
      this.chave++;
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    formataDataUTC(data) {
      const parsedDate = moment(data, 'DD/MM/YYYY', true);
      if (!parsedDate.isValid()) {
        return 'Data inválida';
      }
      return parsedDate.utc().format('DD/MM/YYYY');
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
        // this.idEmpresa = this.decoded.id_empresa;
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    buscaDados() {
      this.selected = [];
      this.$vs.loading();
      var objSend = {};
      if (this.filtro) {
        objSend = { ...this.filtro };
        objSend.dataInicial = moment(this.filtro.dataInicial).format(
          'YYYY-MM-DD',
        );
        objSend.dataFinal = moment(this.filtro.dataFinal).format('YYYY-MM-DD');
        if (this.filtro.regional) {
          const regionaisFiltro = this.filtro.regional.map((item) => item.id);
          objSend.regional = regionaisFiltro;
        }
      } else {
        objSend.tipoData = DATE_TYPES[0];
        objSend.dataInicial = moment()
          .add(-this.filtroDiasAnteriores, 'days')
          .format('YYYY-MM-DD');
        objSend.dataFinal = moment().format('YYYY-MM-DD');
      }
      if (!objSend.status || objSend.status.length === 0) {
        objSend.status = Object.values(STATUS_PROPOSTA)
          .map(({ id, name }) => ({
            id,
            label: name,
          }))
          .filter((item) => {
            return ![
              STATUS_PROPOSTA.COTACAO_RECUSADA.id,
              STATUS_PROPOSTA.COTACAO_CANCELADA.id,
            ].includes(item.id);
          });
      }

      objSend.pagina = this.paginaAtual;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = this.idEmpresa;
      objSend.isConsultor = this.isConsultor;

      if (this.vistoria === true) {
        objSend.orderBy = 'dataVistoria';
        objSend.vistoria = this.vistoria;
        if (
          this.$can('Leitura Carteira Individual', 'Vistorias') &&
          !(
            this.$can('Leitura Carteira Completa', 'Vistorias') ||
            this.$can('Leitura Carteira Corretora', 'Vistorias')
          )
        ) {
          objSend.consultor = [
            { id: this.id_usuario, label: this.nomeUsuario },
          ];
        }
        if (this.filtro) {
          if (!this.filtro.status || this.filtro.status.length === 0)
            objSend.status = [
              {
                id: STATUS_PROPOSTA.AGUARDANDO_APROVACAO.id,
                label: STATUS_PROPOSTA.AGUARDANDO_APROVACAO.name,
              },
            ];
        } else {
          objSend.status = [
            {
              id: STATUS_PROPOSTA.AGUARDANDO_APROVACAO.id,
              label: STATUS_PROPOSTA.AGUARDANDO_APROVACAO.name,
            },
          ];
          objSend.dataInicial = null;
        }
      }

      const _permissaoDistribuirVistoria = this.$can(
        'Editar Responsável Vistoria',
        'Vistorias',
      );

      objSend.permissaoDistribuirVistoria = _permissaoDistribuirVistoria
        ? true
        : false;

      this.itens = [];
      service
        .post('Cotacao', 'listarCotacoesFiltro', objSend)
        .then((res) => {
          this.exibir = true;
          this.qtdTotal = res.data.qtd;
          this.qtdPaginas = this.qtdTotal / this.itemsPerPage;

          if (this.qtdPaginas % 1 != 0) this.qtdPaginas++;
          this.qtdPaginas = parseInt(this.qtdPaginas);

          if (this.qtdTotal > 0) {
            res.data.cotacoes.forEach((element) => {
              element.expandeDetalhes = false;
              this.itens.push(this.formataTransacao(element));
            });
          }

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    buscaRegionais() {
      this.$vs.loading();
      service
        .getAll(
          'Usuario',
          {},
          `list/${this.idEmpresa}?idUsuario=${this.id_usuario}`,
        )
        .then((res) => {
          this.$vs.loading.close();
          res.data.forEach(() => {
            this.buscaDados();
          });
        });
    },
    buscaDadosRegionalDefault(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data.forEach((element) => {
            if (element[campoPK] == this.decoded.id_regional) {
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
            }
          });
        });
    },
    formataTransacao(item) {
      item.idProposta = item.id_proposta;
      item.dadosVeiculo = {
        veiculoMarca: item.veiculoMarca,
        veiculoModelo: item.veiculoModelo,
        anoModelo: item.anoModelo,
        anoFabricacao: item.anoFabricacao,
        combustivel: item.combustivel,
        placa: item.placa,
        cilindradas: item.cilindradas,
        cor: item.cor,
        renavam: item.renavam,
        km: item.km,
        chassi: item.chassi,
        restricao: item.restricao,
        restricaoDescricao: item.restricaoDescricao,
        codigoFipe: item.codigoFipe,
        estadoPneu: item.estadoPneu,
        codTipoVeiculo: item.codTipoVeiculo,
        codigoMarca: item.codigoMarca,
        codigoModelo: item.codigoModelo,
        resultadoFipe: item.resultadoFipe,
        valorFipe: item.valorFipe,
        valorCobertura: item.valorCobertura,
        qtdPortas: item.qtdPortas,
        anoExercicioDut: item.anoExercicioDut,
      };
      item.dadosCliente = {
        idProspect: item.id_prospect,
        associado: item.nome,
        email: item.email,
        cpf: item.cpf,
        telefone: item.telefone,
        cidade: item.cidade,
        estado: item.estado,
        tipo: item.tipo,
        endereco: item.endereco,
        cep: item.cep,
        bairro: item.bairro,
        numero: item.numero,
        complemento: item.complemento,
        dataNascimento: moment(item.dataNascimento).format('DD/MM/YYYY'),
        rg_ie: item.rg_ie,
        cnh: item.cnh,
        catCnh: item.catCnh,
        representanteLegal: item.representanteLegal,
        cpfRepresentante: item.cpfRepresentante,
        dataVencimentoCnh: moment(item.dataVencimentoCnh).format('DD/MM/YYYY'),
      };
      return item;
    },
    openSideBar(dados) {
      dados.idProposta == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
    },
    async openModal(cod) {
      try {
        this.$vs.loading();
        this.popupActive = true;

        if (cod) {
          const res = await service.post('Cotacao', 'listarCotacoes', {
            idProposta: cod,
          });
          this.modalSelecionado = res.data[0];
          const quotation = await autoApi.getQuotation(cod);

          this.totalProductsPrize = quotation.prize.prize;

          const productsFilter = await this.selectCoveragesDetails(quotation);

          this.modalSelecionado.produtos = productsFilter;
        }
      } catch (error) {
        console.error('Erro ao carregar a cotação:', error);
      } finally {
        this.$vs.loading.close();
      }
    },

    selectCoveragesDetails(produtos) {
      return produtos.coverage_contracted
        .map((contract) => {
          return produtos.all_coverages.details.find(
            (detail) => detail.id === contract.id,
          );
        })
        .filter((detail) => detail !== undefined && detail !== null);
    },

    openModalRecusa(item) {
      this.formRecusa = {
        idProposta: item.idProposta,
        idApolice: item.apolice_id,
        obsRecusa: null,
        idMotivoRecusa: null,
        idTipoApolice: item.idTipoApolice,
      };
      this.popRecusa = true;
    },
    openModalAntiFraud(item) {
      this.idApolice = item.apolice_id;
      this.popAntiFraud = true;
    },
    openModalConfirmaEstorno(item) {
      this.formConfirmaEstorno.idTipoApolice = item.idTipoApolice;
      this.formConfirmaEstorno.idApolice = item.idApolice;
      this.popConfirmaEstorno = true;
    },
    async confirmRefund() {
      if (this.isLifePolicy(this.formConfirmaEstorno.idTipoApolice)) {
        try {
          await lifeService.confirmRefund(
            this.formConfirmaEstorno.idApolice,
            this.formConfirmaEstorno.refundDate,
            this.formConfirmaEstorno.refundValue,
          );
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: `Proposta Estornada com sucesso`,
            color: 'success',
          });
          this.popConfirmaEstorno = false;
          this.buscaDados();
        } catch (error) {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: error,
            color: 'danger',
          });
        }
      }
    },

    openModalHistorico(id, nomeStatus, data) {
      this.dadosHistorico = {
        id: id,
        nomeStatus: nomeStatus,
        data: data,
      };
    },

    concluido() {
      this.chave++;
      this.buscaDados();
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
    getStatusColor(data) {
      return functions.getStatusColor(data);
    },
    getStatusString(data) {
      if (data == null) return 'Ativo';
      return 'Inativo';
    },
    abrirModalConfirmacaoResponsavelVistoria(id) {
      this.idProposta = id;
      this.modalConfirmacaoResponsavelVistoria = true;
    },
    abrirModalResponsavelVistoria(id, idResponsible) {
      this.idProposta = id;
      this.consultorAnaliseSelecionado = idResponsible;
      this.modalResponsavelVistoria = true;
    },
    tornarResponsavelVistoria(inspectionResponsibleId) {
      if (!this.isRegistrationSector()) {
        this.modalConfirmacaoResponsavelVistoria = false;
        this.modalResponsavelVistoria = false;

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Você não pode assumir a responsabilidade pela vistoria.',
          color: 'warning',
        });
        return;
      }

      const form = {
        idEmpresa: this.idEmpresa,
        idProposta: this.idProposta,
        idUsuarioResponsavelVistoria: inspectionResponsibleId,
      };

      this.$vs.loading();
      service
        .post('Cotacao', 'atualizaResponsavelVistoria', form)
        .then((res) => {
          this.updateNomeResponsavelVistoria(res);

          this.modalConfirmacaoResponsavelVistoria = false;
          this.modalResponsavelVistoria = false;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });

          this.modalConfirmacaoResponsavelVistoria = false;
          this.abrirModalResponsavelVistoria = false;
          this.$vs.loading.close();
        });
    },
    updateNomeResponsavelVistoria(dados) {
      const { idProposta, idUsuarioResponsavelVistoria } = dados.data;

      const { label: nomeResponsavel } = this.colaboradoresCadastro.find(
        (colaborador) => colaborador.id == idUsuarioResponsavelVistoria,
      );

      this.itens.forEach((vistoria) => {
        if (vistoria.id_proposta == idProposta) {
          vistoria.nomeResponsavel = idUsuarioResponsavelVistoria
            ? nomeResponsavel
            : '';
          vistoria.idResponsible = idUsuarioResponsavelVistoria;
        }
      });
    },
    verificarResponsavelVistoria(idResponsavel) {
      return (
        this.$can('Assumir Responsabilidade', 'Vistorias') &&
        this.id_usuario === idResponsavel
      );
    },
    ajustaDataHoraUtc(data) {
      return moment.utc(data).local().format('DD/MM/YYYY HH:mm');
    },
    obterDadosUsuario() {
      this.$vs.loading();
      service
        .post('Usuario', 'buscarUsuario', {
          idEmpresa: this.idEmpresa,
          idUsuario: this.id_usuario,
        })
        .then((res) => {
          const [dadosConsultor] = res.data;
          this.isConsultor = dadosConsultor.consultor;
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    iconeTipoVeiculo(item) {
      if (item == 3) return 'local_shipping';
      if (item == 1) return 'directions_car';
      if (item == 2) return 'two_wheeler';
    },

    // SEGURADORA
    redirectVistoriaV2(chave, apolice) {
      let link = `${URL_VISTORIA}/${chave}`;
      if (apolice == PRODUCT_NAME.VIDA) {
        link = `${URL_VISTORIA_VIDA}/documentos/${chave}`;
      }
      window.open(link, '_blank');
    },
    getApolicesTagText(id) {
      return PRODUCT_TAG[id];
    },
    getProposalIdTagText(item) {
      return `PROPOSTA ${item.proposalNumber}`;
    },
    getPolicyNumberTagText(item) {
      return `APÓLICE ${item.policyNumber}`;
    },
    isEndorsement(item) {
      return item.creationType === POLICY_CREATION_TYPE.ENDORSEMENT.value;
    },
    isPolicy(item) {
      return (
        item.policyNumber &&
        item.idStatusApolice &&
        item.idStatusApolice !== POLICY_STATUSES.OPEN.id &&
        [
          STATUS_PROPOSTA.FINALIZADO.id,
          STATUS_PROPOSTA.APOLICE_FINALIZADA.id,
          STATUS_PROPOSTA.APOLICE_CANCELADA.id,
        ].includes(item.id_Status)
      );
    },
    isProposal(item) {
      return (
        item.proposalNumber &&
        ![
          STATUS_PROPOSTA.COTACAO_ABERTA.id,
          STATUS_PROPOSTA.COTACAO_CANCELADA.id,
          STATUS_PROPOSTA.COTACAO_RECUSADA.id,
        ].includes(item.id_Status)
      );
    },
    getLabelContrato(proposta) {
      if (proposta.dataAdesao) {
        return 'Apólice';
      }
      if (
        proposta.proposal_date &&
        proposta.creationType !== POLICY_CREATION_TYPE.ENDORSEMENT.value
      ) {
        return 'Proposta';
      }

      if (
        proposta.proposal_date &&
        proposta.creationType === POLICY_CREATION_TYPE.ENDORSEMENT.value
      ) {
        return 'Proposta de Endosso';
      }

      if (proposta.creationType === POLICY_CREATION_TYPE.ENDORSEMENT.value) {
        return 'Cotação de Endosso';
      }
      return 'Cotação';
    },
    hasPDF(proposal) {
      const labelContract = this.getLabelContrato(proposal);
      switch (labelContract) {
        case 'Apólice':
          return !!proposal.insurance_policy;
        case 'Proposta':
          return !!proposal.insurance_proposal;
        case 'Proposta de Endosso':
          return !!proposal.insurance_proposal;
        case 'Cotação':
          return !!proposal.insurance_quotation;
        case 'Cotação de Endosso':
          return !!proposal.insurance_quotation;
        default:
          return false;
      }
    },
    openLinkContratoProposta(proposta) {
      let link = null;
      const labelContract = this.getLabelContrato(proposta);
      const typeContractAuto =
        labelContract === 'Cotação' ? 'contratoCotacao' : 'contratoProposta';
      const typeContract =
        proposta.apolice === PRODUCT_NAME.VIDA
          ? 'contratoPropostaVida'
          : typeContractAuto;

      const proposalLink = proposta.insurance_proposal
        ? proposta.insurance_proposal
        : `/${typeContract}/${proposta.chave}`;
      switch (labelContract) {
        case 'Apólice':
          link = proposta.insurance_policy
            ? proposta.insurance_policy
            : `/${typeContract}/${proposta.chave}`;
          break;
        case 'Proposta':
          link = proposalLink;
          break;
        case 'Cotação':
          link = proposta.insurance_quotation
            ? proposta.insurance_quotation
            : `/${typeContract}/${proposta.chave}`;
          break;
        case 'Proposta de Endosso':
          link = proposta.insurance_proposal
            ? proposta.insurance_proposal
            : `endosso/contrato-proposta/${proposta.chave}`;
          break;
        case 'Cotação de Endosso':
          link = proposta.insurance_quotation
            ? proposta.insurance_quotation
            : `endosso/contrato-cotacao/${proposta.chave}`;
          break;
        default:
          link = proposalLink;
      }
      window.open(link, '_blank');
    },
    mostrarBotaoReabrirVistoria(item) {
      if (
        item.idTipoApolice !== TIPOS_APOLICES.AUTO ||
        item.id_Status !== STATUS_PROPOSTA.VISTORIA_EXPIRADA.id
      ) {
        return false;
      }

      const maxInspectionReopeningsConfig =
        process.env.VUE_APP_MAX_REOPENING_INSPECTION;

      const canReopenInFirstSubmission =
        item.number_first_submission_reopenings < maxInspectionReopeningsConfig;

      const canReopenInPending =
        item.number_pending_reopenings < maxInspectionReopeningsConfig;
      const hasBeenRefused = item.qtdRecusa > 0;

      return hasBeenRefused ? canReopenInPending : canReopenInFirstSubmission;
    },
    async reabrirVistoria(item) {
      const controller = 'prior-inspections';
      const action = `${item.inspection_id}/manual-reopen-inspection`;
      try {
        this.$vs.loading();
        await lifeService.update(controller, null, action);
        notify.notifySuccess(this.$vs, 'Vistoria reaberta com sucesso!');
        this.buscaDados();
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Erro ao reabrir vistoria. Tente novamente.',
        );
      } finally {
        this.$vs.loading.close();
      }
    },
    needInspectionLabel(value, inspectionData) {
      const needInspection = value == null ? null : !!value;
      const alreadySentInspection = inspectionData !== null;
      const label = needInspection ? 'Com Vistoria' : '';
      const showLabel = needInspection && alreadySentInspection;

      return {
        showLabel,
        label,
      };
    },
    isRegistrationSector() {
      const raw = functions.getDecoded(localStorage).sectorId;
      const sectorId = Number(raw);

      const setor = this.listSetores.find((s) => s.id === sectorId);

      return setor && String(setor.label).toLowerCase() === 'cadastro';
    },
  },
  created() {
    this.getDecoded();
    this.verificaAdmin();
    this.idEmpresa = localStorage.getItem('idEmpresa');
  },
  mounted() {
    this.obterDadosUsuario();
    this.buscaRegionais('regionais', 'regionais', 'nome', 'idRegional');
    this.buscaDadosRegionalDefault(
      'regionais',
      'regionalDefault',
      'nome',
      'idRegional',
    );
    functions.buscaDadosSelects(
      'setor',
      this.listSetores,
      'nomeSetor',
      'idSetor',
      `idEmpresa/${this.idEmpresa}`,
    );
    this.isMounted = true;
    this.screenWidth = window.innerWidth;
  },
};
</script>
<!------------ END SCRIPT ------------>

<style scoped src="../../assets/css/listCard.css"></style>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }

  @media screen and (max-width: 768px) {
    .con-vs-popup {
      background-color: red;
      position: fixed;
    }
  }
}

.vs-button.includeIcon {
  float: left;
  margin-right: 5px;
}

.vs-chip-bg-pink {
  background-color: rgb(255, 68, 0);
}

.vs-chip-bg-blue {
  background-color: navy;
}

@media screen and (max-width: 768px) {
  .vue-back-to-top {
    margin-bottom: 35px;
  }
}
</style>
<style>
#refusal-reason-popup.con-vs-popup .vs-popup {
  width: 60% !important;
}

.refusal-reason-popup-overflow {
  overflow: visible;
}
</style>

<!------------ END STYLE ------------>
<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
</style>
